import script from "./AddSpecialNoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSpecialNoteModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSpecialNoteModal.vue?vue&type=style&index=0&id=6dc71cef&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc71cef"]])

export default __exports__